export const PRODUCT_LIST_REQUEST = "PRODUCT_LIST_REQUEST";
export const PRODUCT_LIST_SUCCESS = "PRODUCT_LIST_SUCCESS";
export const PRODUCT_LIST_FAIL = "PRODUCT_LIST_FAIL";
export const PRODUCT_LIST_RESET = "PRODUCT_LIST_RESET";

export const PRODUCT_STATS_REQUEST = "PRODUCT_STATS_REQUEST";
export const PRODUCT_STATS_SUCCESS = "PRODUCT_STATS_SUCCESS";
export const PRODUCT_STATS_FAIL = "PRODUCT_STATS_FAIL";
export const PRODUCT_STATS_RESET = "PRODUCT_STATS_RESET";

export const PRODUCT_SINGLE_REQUEST = "PRODUCT_SINGLE_REQUEST";
export const PRODUCT_SINGLE_SUCCESS = "PRODUCT_SINGLE_SUCCESS";
export const PRODUCT_SINGLE_FAIL = "PRODUCT_SINGLE_FAIL";
export const PRODUCT_SINGLE_RESET = "PRODUCT_SINGLE_RESET";

export const PRODUCT_PER_SERVICE_REQUEST = "PRODUCT_PER_SERVICE_REQUEST";
export const PRODUCT_PER_SERVICE_SUCCESS = "PRODUCT_PER_SERVICE_SUCCESS";
export const PRODUCT_PER_SERVICE_FAIL = "PRODUCT_PER_SERVICE_FAIL";
export const PRODUCT_PER_SERVICE_RESET = "PRODUCT_PER_SERVICE_RESET";

export const CREATE_PRODUCT_REQUEST = "CREATE_PRODUCT_REQUEST";
export const CREATE_PRODUCT_SUCCESS = "CREATE_PRODUCT_SUCCESS";
export const CREATE_PRODUCT_FAIL = "CREATE_PRODUCT_FAIL";
export const CREATE_PRODUCT_RESET = "CREATE_PRODUCT_RESET";

export const UPDATE_PRODUCT_REQUEST = "UPDATE_PRODUCT_REQUEST";
export const UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS";
export const UPDATE_PRODUCT_FAIL = "UPDATE_PRODUCT_FAIL";
export const UPDATE_PRODUCT_RESET = "UPDATE_PRODUCT_RESET";

export const DELETE_PRODUCT_REQUEST = "DELETE_PRODUCT_REQUEST";
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
export const DELETE_PRODUCT_FAIL = "DELETE_PRODUCT_FAIL";
export const DELETE_PRODUCT_RESET = "DELETE_PRODUCT_RESET";
